import { LoginCredentials, User, ForgotPasswordData } from "../types/auth";
import { ApiService } from "./apiService";
import { log, logError } from "../config/environment";

interface LoginApiResponse {
  data: {
    user: User;
    token: string;
  };
  message?: string;
}

export class AuthService {
  static async login(
    credentials: LoginCredentials
  ): Promise<{ data: { user: User; token: string } }> {
    try {
      log("Attempting login via API...");

      // Call the API login endpoint
      const response = await ApiService.post<any>("/login", {
        email: credentials.email,
        password: credentials.password,
      });

      return response;
    } catch (error) {
      logError("❌ Login failed:", error);
      throw new Error((error as Error)?.message || "Login failed");
    }
  }

  static async logout(): Promise<void> {
    try {
      log("Logging out...");

      // Clear local storage
      localStorage.removeItem("token");

      // Optionally call logout endpoint if available
      // await ApiService.post('/logout');

      log("✅ Logout successful");
    } catch (error) {
      logError("❌ Logout failed:", error);
      // Even if API call fails, clear local storage
      localStorage.removeItem("token");
      throw new Error((error as Error)?.message || "Logout failed");
    }
  }

  static async getCurrentUser(): Promise<User> {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        throw new Error("No authentication token found");
      }

      log("Fetching current user from API...");

      // Call API to get current user (assuming /me or /user endpoint)
      // Adjust endpoint based on your API structure
      const response = await ApiService.get<User>("/me");

      if (!response || !response.id) {
        throw new Error("Invalid user data received");
      }

      log("✅ Current user fetched successfully");

      return response;
    } catch (error) {
      logError("❌ Failed to get current user:", error);

      // If unauthorized, clear token
      // if (error?.response?.status === 401) {
      //   localStorage.removeItem("token");
      // }

      const errorMessage =
        // error?.response?.data?.message ||
        // error?.response?.data?.error ||
        // error?.message ||
        "Failed to get current user";

      throw new Error(errorMessage);
    }
  }

  static async getUserDetails(): Promise<any> {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        throw new Error("No authentication token found");
      }
      // Call API to get user details
      const response = await ApiService.get<any>("/users-details");

      return response;
    } catch (error) {
      console.log("error======", error);
    }
  }

  static async forgotPassword(
    data: ForgotPasswordData
  ): Promise<{ message: string }> {
    // Mock implementation - replace with actual API call
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ message: "Password reset link sent to your email" });
      }, 1000);
    });
  }

  static async resetPassword(
    token: string,
    password: string
  ): Promise<{ message: string }> {
    // Mock implementation - replace with actual API call
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ message: "Password reset successfully" });
      }, 1000);
    });
  }
}
